import { Paper } from '@mui/material'
import { SettingsRowCardBody } from '@/components/Settings/SettingsRowCardBody'
import { SettingsRowCardWithTitle } from '@/components/Settings/SettingsRowCardWithTitle'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'

/**
 * Single settings metric card (KPI `Paper`). Optional `title` renders above the card.
 *
 * @param {{
 *   label: string,
 *   caption: string,
 *   value?: string | number,
 *   LabelIcon?: import('react').ComponentType,
 *   title?: string,
 *   groupPosition?: 'single' | 'first' | 'middle' | 'last',
 *   paperClassName?: string,
 *   sx?: import('@mui/material').SxProps,
 *   kpiDescription?: boolean,
 * }} props
 */
export default function SettingsRowCard(props) {
  const { title, label, caption, value, LabelIcon, groupPosition, paperClassName, sx, kpiDescription = false } = props

  if (title) {
    return (
      <SettingsRowCardWithTitle
        title={title}
        label={label}
        caption={caption}
        value={value}
        LabelIcon={LabelIcon}
        groupPosition={groupPosition}
        paperClassName={paperClassName}
        kpiDescription={kpiDescription}
      />
    )
  }

  const sxList = sx ? (Array.isArray(sx) ? sx : [sx]) : []
  const paperCn = [settingsRowPaperClassName({ groupPosition, compactY: false }), paperClassName].filter(Boolean).join(' ')

  return (
    <Paper elevation={0} className={paperCn} sx={sxList.length ? sxList : undefined}>
      <SettingsRowCardBody value={value} label={label} caption={caption} LabelIcon={LabelIcon} kpiDescription={kpiDescription} />
    </Paper>
  )
}
